// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lMBh","type":"styles_type__12WgZ","choices":"styles_choices__3GanR"};